import React, { useState } from "react";
import "./Development.scss";
import DevelopmentHeader from "../components/development/DevelopmentHeader.jsx";
import DevelopmentProjects from "../components/development/DevelopmentProjects.jsx";
import DevelopmentInfo from "../components/development/DevelopmentInfo.jsx";
import DevelopmentModal from "../components/development/DevelopmentModal.jsx";
import Projects from "../data/projects.js";

function Development() {
  const [modalProject, setModalProject] = useState(null);
  const [modalIsShown, setModalIsShown] = useState(false);
  const [fadeClass, setFadeClass] = useState("fade-in");

  const openModal = (project) => {
    setModalProject(project);
    setModalIsShown(true);
    document.body.style.overflow = "hidden";
  };

  const closeModal = (event) => {
    event.preventDefault();
    setFadeClass("fade-out");
    document.body.style.overflow = "auto";
    setTimeout(() => {
      setModalIsShown(false);
      setFadeClass("fade-in");
    }, 1000);
  };

  return (
    <>
      <div id="development-container">
        {modalIsShown ? (
          <DevelopmentModal
            closeModal={closeModal}
            modalProject={modalProject}
            setFade={fadeClass}
          />
        ) : null}

        <div id="development-header-container">
          <DevelopmentHeader />
          <div id="development-header-title-info-container">
            <div id="development-header-title">
              <h1 className="fade-in two">DEVELOPMENT</h1>
            </div>
          </div>
          <DevelopmentInfo />
        </div>
        <div id="development-body">
          <div id="development-projects-container" className="fade-in four">
            <h1>PROJECTS</h1>
            <div id="development-projects">
              <DevelopmentProjects
                openModal={openModal}
                projects={Projects}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Development;
